// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      REPORTS: 'Reports',
      COMPETITORS: 'Competitors',
      X_REF: 'X-Ref',
      ESSITY_PRODUCTS: 'Essity products',
      SETTINGS: 'Settings',
      LISTS: 'Lists',
    },
    GENERAL: {
      CHARACTERISTICS:
        'drag the slider or enter data to select the rothwell range',
    },
    MODAL: {
      SAVE: 'Save',
      CANCEL: 'Cancel',
      YES: 'Yes',
      NO: 'No',
      DELETE_MESSAGE: 'Are you sure to permanently delete',
      ADD_NEW_USER: 'Add new user',
      ADD_NEW_ROLE: 'Add new role',
      EDIT_USER: 'Edit user',
      EDIT_ROLE: 'Edit role',
      VIEW_USER: 'View user details',
      DELETE_USER: 'Delete User',
      DELETE_ROLE: 'Delete Role',
      UPDATE_USER_PASSWORD: 'Update user password',
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications',
      ALERTS: 'Alerts',
      UPDATES: 'Updates',
      LOGS: 'Logs',
      VIEW_ALL: 'View all',
      UPGRADE: 'Upgrade',
      GET_PRO_ACCESS: 'Get pro access',
    },
    IDENTITY: {
      TITLE: 'Identity',
      USERS: 'Users',
      NEW_USER: 'New User',
      NEW_ROLE: 'New Role',
      SEARCH: 'Search',
      USER_NAME: 'User name',
      FIRST_NAME: 'First Name',
      EMAIL: 'Email',
      ROLE: 'Role',
      ROLE_NAME: 'Role Name ',
      ACTIONS: 'Actions',
      SHOW: 'Showing',
      TO: 'to',
      OF: 'of',
      ENTRIES: 'entries',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        PLEASE_WAIT: 'Please wait',
        CONTINUE: 'Continue',
        LOGIN: 'Login',
      },
      LOGIN: {
        TITLE: 'Login with',
        BUTTON: 'Sign In',
        NEW_HERE: 'New Here',
        CONTINUE_WITH_GOOGLE: 'Continue with Google',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        ALREADY_HAVE_ACCOUNT: 'Already have account',
        SIGN_IN: 'Sign In',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
        AGREE: 'I agree with',
        TERMS_AND_CONDITIONS: 'terms and conditions',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        MUST_MATCH: "Passwords don't match!",
      },
    },
    DASHBOARD: {
      WELCOME_MESSAGE: 'Welcome home',
      LANGUAGE: 'Language',
      SIGN_OUT: 'Sign out',
      DATE_RANGE_PICKER: 'Date range picker',
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      LAST_7_DAYS: 'Last 7 days',
      LAST_30_DAYS: 'Last 30 days',
      THIS_MONTH: 'This month',
      LAST_MONTH: 'Last month',
      ALL_TIME: 'All time',
    },
    ACCOUNT: {
      OVERVIEW: 'Overview',
      SETTINGS: 'Settings',
      PROFILE_DETAILS: 'Profile details',
      FULL_NAME: 'Full name',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      CONTACT_PHONE: 'Contact phone',
      COMMUNICATION: 'Communication',
      ALLOW_CHANGES: 'Allow changes',
      YES: 'Yes',
      AVATAR: 'Avatar',
      CHANGE_AVATAR: 'Change Avatar',
      CHOOSE_FILE: 'Choose File',
      SAVE_CHANGES: 'Save Changes',
      EDIT_PROFILE: 'Edit Profile',
      PROFILE_DETAILS_UPDATED: 'Profile details are updated!',
    },
    SIGN_IN_METHOD: {
      TITLE: 'Sign-In Method',
      EMAIL_ADDRESS: 'Email Address',
      CHANGE_EMAIL: 'Change Email',
      PASSWORD: 'Password',
      CURRENT_PASSWORD: 'Current Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_CURRENT_PASSWORD: 'Confirm New Password',
      RESET_PASSWORD: 'Reset password',
      ENTER_NEW_EMAIL_ADDRESS: 'Enter new email address',
      UPDATE_EMAIL: 'Update Email',
      UPDATE_PASSWORD: 'Update password',
      CANCEL: 'Cancel',
      PASSWORD_WAS_UPDATED: 'Password has been updated successfully',
      INCORRECT_PASSWORD: 'Incorrect password',
      PASSWORD_RULE:
        'Password must be at least 6 character and contain symbols',
      VALIDATION: {
        CURRENT_PASS_REQUIRED: 'Current password is required!',
        CURRENT_PASS_MIN: 'Current password should have at least 6 symbols',
        CURRENT_PASS_MAX: 'Current password should have maximum 25 symbols',
        NEW_PASS_REQUIRED: 'New password is required!',
        NEW_PASS_MIN: 'New password should have at least 6 symbols',
        NEW_PASS_MAX: 'New password should have maximum 25 symbols',
        CONFIRM_PASS_REQUIRED: 'Current password is required!',
        PASS_DO_NOT_MATCH: "Passwords don't match!",
      },
    },
    FOOTER: {
      RIGHTS: 'All rights reserved',
    },
  },
};
